module.exports = __webpack_public_path__ + "media/images/img-secondcarrier-8-d5207a0e.jpg";